import React, { createContext, useContext } from 'react';
import { ToolState, ToolAction } from '../hooks/useToolState';

interface ToolContextType {
  tool: ToolState;
  dispatch: React.Dispatch<ToolAction>;
}

const ToolContext = createContext<ToolContextType | null>(null);

export const ToolProvider: React.FC<{ value: ToolContextType; children: React.ReactNode }> = ({ value, children }) => (
  <ToolContext.Provider value={value}>{children}</ToolContext.Provider>
);

export const useToolContext = () => {
  const context = useContext(ToolContext);
  if (!context) {
    throw new Error('useToolContext must be used within a ToolProvider');
  }
  return context;
};
